import { render, staticRenderFns } from "./TicketListViewOld.vue?vue&type=template&id=2cd1db12&scoped=true"
import script from "./TicketListViewOld.vue?vue&type=script&lang=js"
export * from "./TicketListViewOld.vue?vue&type=script&lang=js"
import style0 from "./TicketListViewOld.vue?vue&type=style&index=0&id=2cd1db12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd1db12",
  null
  
)

export default component.exports